import { useApiClient } from '../lib/api-client.js';
import { useQuery } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

function useDropdownOptions(endpoint, labelField = 'name', valueField = 'id', searchTerm = '', page = 1, limit = 25, filters) {
    const apiClient = useApiClient();
    const queryFn = useCallback(async () => {
        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString(),
        });
        if (searchTerm && searchTerm.trim()) {
            params.append('search', searchTerm.trim());
        }
        // Add filters to query params
        if (filters) {
            Object.entries(filters).forEach(([key, value]) => {
                if (value !== undefined && value !== null) {
                    params.append(`where[${key}][equals]`, String(value));
                }
            });
        }
        return apiClient.get(`${endpoint}?${params.toString()}`);
    }, [apiClient, endpoint, page, limit, searchTerm, filters]);
    const { data, isLoading, error } = useQuery({
        queryKey: ['dropdown-options', endpoint, labelField, valueField, searchTerm, page, limit, filters],
        queryFn,
        staleTime: 30000, // Keep data fresh for 30 seconds
        gcTime: 5 * 60 * 1000, // Keep in cache for 5 minutes
    });
    const options = useMemo(() => (data?.data || []).map((item) => ({
        label: String(item[labelField] ?? ''),
        value: String(item[valueField] ?? ''),
    })), [data?.data, labelField, valueField]);
    return useMemo(() => ({
        options,
        isLoading,
        error,
        hasMore: data ? data.pagination.page * data.pagination.limit < data.pagination.total : false,
        total: data?.pagination?.total || 0,
    }), [options, isLoading, error, data]);
}
function useTourTypeOptions() {
    return useDropdownOptions('tour-types');
}
function useGreaterAreaOptions() {
    return useDropdownOptions('greater-areas');
}

export { useDropdownOptions, useGreaterAreaOptions, useTourTypeOptions };
//# sourceMappingURL=useDropdownOptions.js.map
